import React from "react";
import "./FindOurProducts.css";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import GoOutW from "../../../Assets/Svg/FindOurProducts/GoOutWAr.svg";
import FindOurProducts1 from "../../../Assets/images/FindOurProducts/FindOurProducts1N.png";
import FindOurProducts2 from "../../../Assets/images/FindOurProducts/breadfast-brand.svg";
import { useIsMobile } from "../../../Component/Hooks/IsMobile/IsMobile";
import NotFound from "../../../Component/404/NotFound";
export default function FindOurProductsAr() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <>
        <div className="FOPC">
          <FOPS1 />
          <FOPS2 />
          <FOPS3 />
          <FOPS4 />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="FOPC">
        <NotFound />
      </div>
    </>
  );
}

function FOPS1() {
  return (
    <>
      <div className="FOPS1">
        <TC3L
          Head="أين يمكنك العثور على منتجاتنا"
          Title="المتاجر الإلكترونية"
          Para="لراحة عملائنا، تتوفر منتجاتنا أيضًا عبر الإنترنت من خلال شركاء التجارة الإلكترونية المختارين"
          ParaWidth="55vw"
        />
      </div>
    </>
  );
}

function FOPS2() {
  return (
    <>
      <div className="FOPS2" dir="rtl">
        <FOPS2Box
          StoreImg={FindOurProducts1}
          ImgAlt="Talabat"
          StoreImgWidthWeb="15vw"
          StoreImgWidthMob="60vw"
          StoreName={<>طلبات</>}
          StoreButtonUrl="https://pzwv.adj.st/?c=eg&s=ds&t=2&i=6c97af03-723f-4fb4-a4ba-6ea3c438c87c&adj_t=ubpopz9_qyj4s1t&adj_campaign=other_other_mix_gro_ma_eg_display_Milkys&adj_adgroup=Social&adj_creative=AllProducts&adj_deeplink=talabat%3A%2F%2F%3Fc%3Deg%26s%3Dds%26t%3D2%26i%3D6c97af03-723f-4fb4-a4ba-6ea3c438c87c&adj_fallback=https%3A%2F%2Fwww.talabat.com%2Fegypt%2Ftmart-new-maadi--taqseem-laselky%3Futm_campaign%3Dother_other_web_gro_ma_eg_display_Milkys%26utm_source%3DSocial%26utm_medium%3Dother"
        />
        <FOPS2Box
          StoreImg={FindOurProducts2}
          ImgAlt="بريدفاست"
          StoreImgWidthWeb="10vw"
          StoreImgWidthMob="40vw"
          StoreName={<>بريدفاست</>}
          StoreButtonUrl="https://app.breadfast.com/?type=collection&id=675ae717eb86ea59901b38df&flow=now"
        />
      </div>
    </>
  );
}

function FOPS2Box({ StoreImg, ImgAlt, StoreImgWidthWeb, StoreImgWidthMob, StoreName, StoreButtonUrl }) {
  const isMobile = window.innerWidth <= 756;
  return (
    <>
      <div className="FOPS2Box">
        <div className="FOPS2BoxP1">
          <div className="FOPS2BoxP1Box">
            <img src={StoreImg} alt={ImgAlt} className="FOPS2BoxP1Img" style={{ width: isMobile ? StoreImgWidthMob : StoreImgWidthWeb }} />
          </div>
          <div className="FOPS2BoxP2 TGLo32PxPC ar">{StoreName}</div>
        </div>
        <div className="FOPS2BoxP3">
          <a href={StoreButtonUrl} target="Blank" className="FOPS2BoxP3A">
            <div className="TFut16PxPCUC FOPS2BoxP3T ar">افتح المتجر</div>
            <div>
              <img src={GoOutW} alt="GoOutW" />
            </div>
          </a>
        </div>
      </div>
    </>
  );
}

function FOPS3() {
  return (
    <>
      <div className="">
        <TC3L
          Head="كن شريكًا معنا"
          Title="لماذا الشراكة معنا؟"
          Para="هل أنت بائع تجزئة تتطلع إلى الارتقاء بعروض منتجاتك من خلال منتجات عالية الجودة ومستدامة ولذيذة؟ يمكن أن تكون الشراكة مع Milky’s فرصة مفيدة للطرفين."
          ParaWidth="55vw"
        />
      </div>
    </>
  );
}
function FOPS4() {
  return (
    <>
      <div className="FOPS4" dir="rtl">
        <FOPS4Box Title="منتجات مميزة" Para="يتم تصنيع منتجاتنا بعناية، باستخدام الطرق التقليدية وأفضل المكونات." />
        <FOPS4Box Title="سمعة العلامة التجارية القوية" Para="لقد قمنا ببناء قاعدة عملاء مخلصة وسمعة قوية للعلامة التجارية." />
        <FOPS4Box Title="دعم التسويق" Para="نحن نقدم لك المواد التسويقية والدعم لمساعدتك في الترويج لمنتجاتنا." />
        <FOPS4Box Title="أسعار تنافسية" Para="يضمن هيكل التسعير التنافسي لدينا الربحية لشركتك." />
      </div>
    </>
  );
}

function FOPS4Box({ Title, Para }) {
  return (
    <>
      <div className="FOPS4Box ar">
        <div className="FOPS4BoxP1 ar TGLo32PxPC">{Title}</div>
        <div className="FOPS4BoxP2 ar TFut20PxPC">{Para}</div>
      </div>
    </>
  );
}
